import { Component, DestroyRef, inject, OnDestroy } from '@angular/core';
import { TranslatorService } from '../../../services/translator_service';
import { ResponsiveService } from '../../../services/responsive.service';
import { ApiQuery } from '../../../web-services/api/api.query';
import { CommonModule } from '@angular/common';
import { RTLDivDirectiveDirective } from '../../../directives/rtldiv-directive.directive';
import { TranslateModule } from '@ngx-translate/core';
import { FormsModule } from '@angular/forms';
import { BinFilteredSamplesComponent } from './bin-filtered-samples/bin-filtered-samples.component';
import { BinUnfilteredSamplesComponent } from './bin-unfiltered-samples/bin-unfiltered-samples.component';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-bin-capacity',
  standalone: true,
  imports: [CommonModule,TranslateModule,RTLDivDirectiveDirective,FormsModule,BinFilteredSamplesComponent,BinUnfilteredSamplesComponent],
  templateUrl: './bin-capacity.component.html',
  styleUrl: './bin-capacity.component.scss'
})
export class BinCapacityComponent implements OnDestroy {
	isMobile: boolean;
	translationsObj;
	currentLang;
  isUnfilteredTransmission:boolean = false;
	user_role_id = 0;
	private readonly destroy$ = new Subject<void>();

	constructor(private translator: TranslatorService,private responsiveService: ResponsiveService,private apiQuery:ApiQuery) {
    this.translator.currentLangEmitter$
    .pipe(takeUntil(this.destroy$))
    .subscribe(async value=>{						
      this.translationsObj = await this.translator.getTranslation(value).toPromise()			 
      this.currentLang = value;
    })
  }

  ngOnInit() {
    this.onResize();
    this.responsiveService.checkWidth();

    this.apiQuery.user$.pipe(takeUntil(this.destroy$)).subscribe(user => {
			if (!user) return;
      this.user_role_id = user["user_role_id"];
		});
  }

  onResize() {
    this.responsiveService.getMobileStatus().pipe(takeUntil(this.destroy$)).subscribe(isMobile => {
      this.isMobile = isMobile;
    });
  }

  ngOnDestroy(): void {
		this.destroy$.next();
		this.destroy$.complete();
	}

  unfilteredTransmissionBtn(value){
    this.isUnfilteredTransmission = value;
  }
}
